import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HttpService, NotificationService, PurchaseOrderLineStockIssue, TmsWebBaseEditService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class PurchaseOrderStockIssueService extends TmsWebBaseEditService<
  PurchaseOrderLineStockIssue,
  PurchaseOrderLineStockIssue
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('PurchaseOrderStockIssue', $localize`Purchase Order Stock Issue`, httpService, notificationService);
  }

  issue(purchaseOrderLineId: string, stockItemId?: string): Observable<any> {
    return this.httpService.post<any>(`${this.apiUrl}/Issue`, {
      purchaseOrderLineId,
      stockItemId,
    });
  }

  unIssue(purchaseOrderLineId: string) {
    return this.httpService.post<any>(`${this.apiUrl}/UnIssue`, { purchaseOrderLineId });
  }
}
